import React, { useState } from 'react'
import { Button, FloatingLabel, Form, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

type Props = {
    show: boolean
    setShow: (value: boolean) => void
    comments: any[]
    addComment: (data: any) => void
}

const Comment: React.FC<Props> = ({
    show,
    setShow,
    comments,
    addComment
}) => {

    const {t} = useTranslation()

    const [comment, setComment] = useState('')
    const handleComment = () => {
        addComment(comment)
        setComment('')
    }

    const dateNow = () => {
        let today = new Date()
        let dd = String(today.getDate()).padStart(2, '0')
        let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
        let yyyy = today.getFullYear()
        let hh = String(today.getHours()).padStart(2, '0')
        let mmm = String(today.getMinutes()).padStart(2, '0')
        let ss = String(today.getSeconds()).padStart(2, '0')
        return (dd + '-' + mm + '-' + yyyy + " " + [
          hh, mmm, ss
        ].join(":"))
    }

    return <>
    <Modal
            show={show}
            onHide={() => setShow(false)}
            centered
            backdrop='static'
            size='lg'
            scrollable
            >
            <Modal.Header closeButton>
                <Modal.Title>{t('Comment')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FloatingLabel controlId='floatingTextarea2' label={t('Comment')}>
                <Form.Control
                    as='textarea'
                    id='areacomment'
                    placeholder={t('Tinggal-pesan')}
                    value={comment}
                    onChange={(e: any) => setComment(e.target.value)}
                    style={{height: '100px'}}
                />
                </FloatingLabel>
                <div className='d-flex justify-content-end mt-3 mb-3'>
                <Button variant='primary' onClick={() => handleComment()}>
                    {t('Submit')}
                </Button>
                </div>
                {comments.length < 1 ? (
                ''
                ) : (
                <div className='table-responsive mt-10 bdr'>
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead>
                        <tr className='fw-bold w-100 align-items-center'>
                        <th className='td-3 text-center'>{t('no')}</th>
                        <th className='td-3 text-center'>{t('order-tanggal')}</th>
                        <th className='td-3 text-center'>{t('order-user')}</th>
                        <th className='td-3 text-center'>{t('Comment')}</th>
                        </tr>
                    </thead>
                    {comments.map((item: any, _index: number) => (
                        <tbody key={item?.id ?? _index}>
                        <tr className='w-100 align-items-center'>
                            <td className='td-150 text-center'>{_index + 1}</td>
                            <td className='td-150 text-center'>{dateNow()}</td>
                            <td className='td-150 text-center'>{localStorage.getItem('username')}</td>
                            <td className='td-60 text-center text-wrap'>
                            <div style={{whiteSpace: 'pre-line'}}>{item}</div>
                            </td>
                        </tr>
                        </tbody>
                    ))}
                    </table>
                    {/* End Table Head */}
                </div>
                )}
            </Modal.Body>
            </Modal>
    </>
}

export default Comment